import { Tabs, type TabsProps } from "@mantine/core";
import { IconCheckbox, IconClipboardText, IconFile } from "@tabler/icons-react";
import type React from "react";

export enum SessionTab {
  PREPARATION = "preparation",
  MATERIALS = "materials",
  SURVEYS = "surveys",
}

export interface SessionTabsProps extends Omit<TabsProps, "children"> {
  activeTab: SessionTab;
  onTabChange: (tab: SessionTab) => void;
  children: React.ReactNode;
}

export const SessionTabs: React.FC<SessionTabsProps> = ({
  activeTab,
  onTabChange,
  children,
  ...tabsProps
}) => {
  return (
    <Tabs
      value={activeTab}
      onChange={(value) => onTabChange(value as SessionTab)}
      {...tabsProps}
    >
      <Tabs.List grow>
        <Tabs.Tab
          value={SessionTab.PREPARATION}
          leftSection={<IconCheckbox size="1.2em" />}
        >
          Preparation
        </Tabs.Tab>
        <Tabs.Tab
          value={SessionTab.MATERIALS}
          leftSection={<IconFile size="1.2rem" />}
        >
          Materials
        </Tabs.Tab>
        <Tabs.Tab
          value={SessionTab.SURVEYS}
          leftSection={<IconClipboardText size="1.2rem" />}
        >
          Surveys
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value={activeTab} pt="xs">
        {children}
      </Tabs.Panel>
    </Tabs>
  );
};
